import { render, staticRenderFns } from "./UserConfirmEmailAddressView.vue?vue&type=template&id=797b7104"
import script from "./UserConfirmEmailAddressView.vue?vue&type=script&lang=js"
export * from "./UserConfirmEmailAddressView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports